import React from "react";
import { RouteType } from "./config";
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import AboutPage from "../pages/about/AboutPage";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BatchesPage from "../pages/skus/SKUPage";
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import UsersPage from "../pages/users/UsersPage";
import APIPage from "../pages/api/APIPage";
import APIIcon from '@mui/icons-material/ApiRounded';
import DevicesPage from "../pages/devices/DevicesPage";
import KeysPage from "../pages/keys/KeysPage";
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import AuditsPage from "../pages/audit/AuditPage";
import CustomerAccountsPage from "../pages/accounts/CustomerAccountsPage";
import CustomerAccountDetailPage from "../pages/accounts/CustomerAccountDetailPage";
import CustomerAccountImportsPage from "../pages/accounts/CustomerAccountImportsPage";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

const appRoutes: RouteType[] = [
    {
        path: "/users",
        element: <UsersPage />,
        state: "users",
        sidebarProps: {
            displayText: "Users",
            icon: <PeopleAltOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/users/:paramID",
        element: <UsersPage />,
        state: "users",
    },
    {
        path: "/sku",
        element: <BatchesPage />,
        state: "sku",
        sidebarProps: {
            displayText: "SKU",
            icon: <BallotOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/sku/:paramID",
        element: <BatchesPage />,
        state: "batches",
    },
    {
        path: "/phone-configuration",
        element: <DevicesPage />,
        state: "phone-configuration",
        sidebarProps: {
            displayText: "Phone Configuration",
            icon: <AssessmentOutlinedIcon fontSize="large" />
        }
    },
    {
        path: "/phone-configuration/:paramID",
        element: <DevicesPage />,
        state: "phone-configuration",
    },
    {
        path: "/customer-accounts",
        element: <CustomerAccountsPage />,
        state: "customer-accounts",
        sidebarProps: { displayText: "Customer Accounts", icon: <BusinessOutlinedIcon fontSize="large" /> }
    },
    { path: "/customer-accounts/:accountId", element: <CustomerAccountDetailPage />, state: "customer-accounts" },
    ...["/customer-accounts/imports/new", "/customer-accounts/imports/:importId", "/customer-accounts/imports"].map(path => ({ path, element: <CustomerAccountImportsPage />, state: "customer-accounts" })),
    {
        path: "/key",
        element: <KeysPage />,
        state: "key",
        sidebarProps: {
            displayText: "Encryption Key",
            icon: <KeyOutlinedIcon fontSize="large" />
        }
    },
    {
        path: "/swagger-api-doc",
        element: <APIPage />,
        state: "api-doc",
        sidebarProps: {
            displayText: "API",
            icon: <APIIcon fontSize="large" />
        }
    },
    {
        path: "/auditlog",
        element: <AuditsPage />,
        state: "auditlog",
        sidebarProps: {
            displayText: "Audit Log",
            icon: <StorageOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/auditlog/:paramID",
        element: <AuditsPage />,
        state: "auditlog",
    },
    {
        path: "/about",
        element: <AboutPage />,
        state: "about",
        sidebarProps: {
            displayText: "About",
            icon: <InfoOutlinedIcon fontSize="large" />,
        }
    },
]

export default appRoutes;
